<template>
    <div>
        <el-row class="full_height">
            <el-col :span="4" class="positon_relative">
                <el-menu class="nav_menu" text-color="#A7CCF6" default-active="1" active-text-color="#fff">
                    <router-link to="/ProjectInfo" class="link">
                        <el-menu-item index="1">
                            <template slot="title">
                                <i class="el-icon-notebook-2"></i>&nbsp;项目信息
                            </template>
                        </el-menu-item>
                    </router-link>
                    <router-link :to="{name:'childprojects'}" class="link">
                        <el-menu-item index="2">
                            <template slot="title">
                                <i class="el-icon-notebook-2"></i>&nbsp;结构信息
                            </template>
                        </el-menu-item>
                    </router-link>
                    <router-link :to="{name:'measures'}" class="link">
                        <el-menu-item index="3">
                            <template slot="title">
                                <i class="el-icon-notebook-2"></i>&nbsp;测点信息
                            </template>
                        </el-menu-item>
                    </router-link>
                    <router-link to="/CedianGroup" class="link">
                        <el-menu-item index="4">
                            <template slot="title">
                                <i class="el-icon-document-copy"></i>&nbsp;测点分组
                            </template>
                        </el-menu-item>
                    </router-link>
                    <router-link to="/AlarmInfor" class="link">
                        <el-menu-item index="5">
                            <template slot="title">
                                <i class="el-icon-sunrise"></i>&nbsp;报警器信息
                            </template>
                        </el-menu-item>
                    </router-link>
                    <router-link :to="{name:'smsAlarm'}" class="link" v-if="isShowSms">
                        <el-menu-item index="6">
                            <template slot="title">
                                <i class="el-icon-setting"></i>&nbsp;
                                短信发送配置
                            </template>
                        </el-menu-item>
                    </router-link>
                    <!--          <router-link to="/DataManagement" class="link">-->
                    <!--            <el-menu-item index="6">-->
                    <!--              <template slot="title">-->
                    <!--                <i class="el-icon-document"></i>&nbsp;资料管理-->
                    <!--              </template>-->
                    <!--            </el-menu-item>-->
                    <!--          </router-link>-->
                </el-menu>
            </el-col>
            <el-col :span="20" class="full_height">
                <router-view class="full_height tab_content"></router-view>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            isShowSms: false
        };
    },
    mounted: function() {
        this.$router.push({ path: "/ProjectInfo" });
        this.getIsShowSms()
    },
    methods: {
        getIsShowSms() {
            this.$axios.get("/api/monitor/index/indexMainInfo").then(res => {
                let data = res.data
                if (data.status == 200) {
                    let mainId = localStorage.getItem("mainId")
                    if (data.datas && data.datas.values && data.datas.values.childProjects) {
                        data.datas.values.childProjects.forEach(item => {
                            if (item.id == mainId) {
                                if (item.smsSwitch == 1) {
                                    this.isShowSms = true
                                }
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
@import "../../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/project/index.vue